export default {
  id: 'applePay',
  cardType: 'Apple Pay',
  source: 'apple_pay',
  isPrimary: true,
  isActive: false,
  name: 'APPLE PAY',
  isApplePay: true
};
